import servicios from '../../Utilidades/servicios';

export default angular.module('contartemx.inicio.mejoras_precios', [
  'contartemx',
  'ui.router',
  'ui.bootstrap',
  'servicios'
])
.controller('MejorasPreciosCtrl', [
  '$scope',
  '$state',
  '$stateParams',
  'ContarteApi',
  'callToWebService',
  'ComprasService',
  'mostrarNotificacion',
  function MejorasPreciosController($scope, $state, $stateParams, ContarteApi, callToWebService, ComprasService, mostrarNotificacion) {
      $scope.useDefaultMembership = $stateParams.default == 'Nuevo';
      //Hacer llamado a WCF
      callToWebService.postCall('ObtenerPantallaMejorasPrecios', {}, function success(data) {
          if (data.Respuesta && !data.EsError) {
              //$scope.timbres = data.Respuesta.Timbres;
              //$scope.timbre_seleccionado = $scope.timbres[0];
              //$scope.membresia = data.Respuesta.Membresias[0];
              $scope.MembresiaActiva = data.Respuesta.MembresiaActiva;
              if ($scope.useDefaultMembership) {
                  $scope.adquirirMembresia();
                  $state.transitionTo('inicio.datos_compra');
              }
          } else {
              if(data.Mensaje)  
                  mostrarNotificacion.error(data.Mensaje);
              else
                  mostrarNotificacion.error("No se puede obtener tu paquete, contacta administrador");
  }
      }, function error(data) {
          alert("Data Error");
      });

      //$scope.adquirirMembresia = function () {
      //    ComprasService.setArticulo($scope.membresia);
      //    ComprasService.setTipoCompra("membresia");
      //};

      //$scope.adquirirTimbres = function () {
      //    ComprasService.setArticulo($scope.timbre_seleccionado);
      //    ComprasService.setTipoCompra("timbres")
      //};

      $scope.EnviarCorreoMembresia = function (ctrl) {
          if ($('#' + ctrl).prop('disabled'))
              return;

          var data = { subject: "Adquirir/Renovar membresia" };
          callToWebService.postCall('EnviarCorreoTimbresMembresias', data, function success(data) {
              if (!data.EsError) {
                  //mostrarNotificacion.info(data.Mensaje);
                  $('#' + ctrl).text('Solicitud enviada');
                  $('#' + ctrl).prop('disabled', true);
              }
              else
                  mostrarNotificacion.error("Hubo un error al mandar la peticion");
          }, function error(data) {
              mostrarNotificacion.error("Hubo un error al mandar la peticion");
          });
      }

      $scope.EnviarCorreoTimbres = function (ctrl) {
          if ($('#' + ctrl).prop('disabled'))
              return;

          var data = { subject: "Adquirir timbres" };
          callToWebService.postCall('EnviarCorreoTimbresMembresias', data, function success(data) {
              if (!data.EsError) {
                  //mostrarNotificacion.info(data.Mensaje);
                  $('#' + ctrl).text('Solicitud enviada');
                  $('#' + ctrl).prop('disabled', true);
              }
              else
                  mostrarNotificacion.error("Hubo un error al mandar la peticion");
          }, function error(data) {
              mostrarNotificacion.error("Hubo un error al mandar la peticion");
          });
      }
  }
])
.service("ComprasService", function () {
    var articulo;
    var tipoCompra;
    var tipoPago;
    return {
        getArticulo: function () {
            return articulo;
        },
        setArticulo: function (valor) {
            articulo = valor
        },
        getTipoCompra: function () {
            return tipoCompra;
        },
        setTipoCompra: function (valor) {
            tipoCompra = valor;
        },
        getTipoPago: function () {
            return tipoPago;
        },
        setTipoPago: function (valor) {
            tipoPago = valor;
        }
    }
});
